import { defineMessages } from "react-intl";

const messages = defineMessages({
  addNewDealButton: {
    id: "associations.deals.addNewDealButton",
    defaultMessage: "+ Add New Deal",
    description: "Add new deal button on Deal association modal",
  },
  alreadyAssociated: {
    id: "associations.deals.alreadyAssociated",
    defaultMessage:
      "This deal is already associated with this record. To remove the association, click the “Remove” icon from the edit panel.",
    description: "A tooltip over the checkbox when deal is already assigned to a target record",
  },
  cantAssociateWithSelf: {
    id: "associations.deals.cantAssociateWithSelf",
    defaultMessage: "Assigning deal to itself is not allowed",
    description: "A tooltip over the checkbox when deal is already a target company",
  },
  createOkButton: {
    id: "associations.deals.addNewDealModal.okButton",
    defaultMessage: "Create and Add Deal",
    description: "Create button title on Create Deal modal when called from Select Deals modal",
  },
  deselectCount: {
    id: "associations.deals.title.deselect.count",
    defaultMessage: "{count, plural, one {# deal} other {# deals}} deselected",
    description: "Title of Deals Association modal with deselected count",
  },
  header: {
    id: "associations.deals.header",
    defaultMessage: "Select {multiselect, select, true {Deals} other {Deal}}",
    description: "Header of Deal Associations modal",
  },
  notEditableRowTooltip: {
    id: "associations.deals.notEditable.rowTooltip",
    defaultMessage: "You don't have permission to edit this deal",
    description: "Tooltip on a disabled deal row the user isn't allowed to link",
  },
  okButton: {
    id: "associations.deals.footer.okButton",
    defaultMessage:
      "{addDeals, select, true {Add} other {Update}} {multiselect, select, true {Deals} other {Deal}}",
    description: "Add button title on Deal Associations modal",
  },
  placeholder: {
    id: "associations.deals.search.placeholder",
    defaultMessage: "Search for a deal",
    description: "Search bar placeholder for deal association modal",
  },
  selectedCount: {
    id: "associations.deals.title.selected.count",
    defaultMessage: "{count, plural, one {# new deal} other {# new deals}} selected",
    description: "Title of Deals Association modal with selected count",
  },
});

export default messages;
